// extracted by mini-css-extract-plugin
export var centerText = "_cm-8";
export var container = "_cm-0";
export var doughnutContainer = "_cm-7";
export var legend = "_cm-a";
export var legendItemColorDisplay = "_cm-b";
export var legendItemLabel = "_cm-d";
export var legendItemValue = "_cm-c";
export var lg = "_cm-5";
export var maxWidth = "_cm-9";
export var md = "_cm-4";
export var responsive = "_cm-6";
export var sm = "_cm-3";
export var xs = "_cm-2";
export var xxs = "_cm-1";